import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillNumberTextV1FieldComponent } from './fill-number-text-v1/fill-number-text-v1.component';
import { ViewNumberTextV1FieldComponent } from './view-number-text-v1/view-number-text-v1.component';
import { SettingsNumberTextV1FieldComponent } from './settings-number-text-v1/settings-number-text-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillNumberTextV1FieldComponent,
        ViewNumberTextV1FieldComponent,
        SettingsNumberTextV1FieldComponent
    ],
    exports: [
        FillNumberTextV1FieldComponent,
        ViewNumberTextV1FieldComponent,
        SettingsNumberTextV1FieldComponent
    ],

})
export class CoreCustomFormsFieldNumberTextV1FieldsModule { }
